import { render } from "./PromoDetailView.vue?vue&type=template&id=a2278052&scoped=true"
import script from "./PromoDetailView.vue?vue&type=script&lang=js"
export * from "./PromoDetailView.vue?vue&type=script&lang=js"

import "./PromoDetailView.vue?vue&type=style&index=0&id=a2278052&scoped=true&lang=css"
import "./PromoDetailView.vue?vue&type=style&index=1&id=a2278052&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2278052"]])

export default __exports__